// utils/authToken.js

// Generic setter with event notification
export const setAuthToken = (value, key) => {
    try {
        if (!value) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, value);
        }

        // Notify listeners (optional but useful)
        window.dispatchEvent(new Event("authTokenChanged"));

    } catch (err) {
        console.error("Auth token write error:", err);
    }
};

// Clear all user authentication data
export const removeAuthToken = () => {
    try {
        const keysToRemove = [
            "_business_panel_token",
            "_type",
            "_id",
            "is_password_reset"
        ];

        keysToRemove.forEach((k) => localStorage.removeItem(k));

        window.dispatchEvent(new Event("authTokenChanged"));
    } catch (err) {
        console.error("Auth token remove error:", err);
    }
};

// Safe storage getter object
export const storage = {
    getUserId: () => localStorage.getItem("_id") || null,
    getUserType: () => localStorage.getItem("_type") || null,
    getUserToken: () => localStorage.getItem("_business_panel_token") || null,
    getUserPasswordReset: () => localStorage.getItem("is_password_reset") || null,

    // Optional: Clear all except token
    clear: () => removeAuthToken()
};
